/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Bags_PrintInputs */

const vi_sinp_bags_print = /** @type {(inputs: Sinp_Bags_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In phiếu`)
};

/**

* @param {Sinp_Bags_PrintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_bags_print = /** @type {((inputs?: Sinp_Bags_PrintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Bags_PrintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_bags_print(inputs)
});